import type { FormFieldVariant } from "@/styles/form-field-variant"
import { getMuiTextFieldVariant } from "@/styles/form-field-variant"

import { FilledInput, Input, OutlinedInput } from "@mui/material"

export const getSelectInput = (
  variant: FormFieldVariant | undefined,
  label?: string
) => {
  switch (getMuiTextFieldVariant(variant) ?? "outlined") {
    case "filled":
      return <FilledInput />
    case "standard":
      return <Input />
    default:
      return <OutlinedInput label={label} />
  }
}
